<template>
  <div class="tools02-bussiness-account-detail-bussiness-account-editor">
    <el-row type="flex" justify="center">
      <el-col :span="18">
        <table class="typeB">
          <tr>
            <th style="width: 250px">
              <span>Yahoo!JAPAN ビジネスID</span>
            </th>
            <td>
              <el-input v-model="bussinessAccountData.bussinessId"></el-input>
              <ValidationErrorMessages :errorMessageList="validationErrorData.bussinessId" />
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: center">
        <el-button @click="register" type="primary">登録</el-button>
        <ValidationErrorMessages :errorMessageList="validationErrorData.id" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: "BussinessAccountEditor",
  components: {
    ValidationErrorMessages,
  },
  props: {
    bussinessAccountId: String,
  },
  data() {
    return {
      // 
      bussinessAccountData: {
        bussinessId: "",
      },

      // 
      validationErrorData: {
        id: [],
        bussinessId: [],
      },
    };
  },
  computed: {
    ...mapGetters(["rt", "tool", "apiErrorMessage"]),
  },
  watch: {
    bussinessAccountId: {
      handler(newValue) {
        this.bussinessAccountData = JSON.parse(
          JSON.stringify(
            this.$store.getters["tools02/bussinessAccountData"](newValue)
          )
        );
      },
      immediate: true,
    },
  },
  methods: {
    register() {
      let params = new URLSearchParams();
      params.append("id", this.bussinessAccountId);
      params.append("bussiness_id", this.bussinessAccountData.bussinessId);
      this.$axios
        .post(`${this.rt}/l/api/tools02/media/yahoo/register-bussiness-account-data`, params)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            // 
            this.$store.dispatch("tools02/setBussinessAccountList");
            this.$store.dispatch("tools02/setAccounts");

            // 
            this.$router.go(-1);
          } else if (response.data.status === 400) {
            this.validationErrorData = response.data.validationErrorData;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
          }
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
